export const ru = {
    header: {
      business: "Бизнес",
      client: "Клиент",
    },
    hero: {
      title: "Быстрые и надежные платежи для бизнеса и пользователей",
      subtitle: "Принимайте криптовалюту и фиат, мгновенные транзакции, полная безопасность",
      businessButton: "Подключить бизнес",
      walletButton: "Создать кошелек",
    },
    features: {
      title: "Преимущества Feennex",
      items: {
        fastTransactions: {
          title: "Быстрые транзакции",
          description: "Мгновенные переводы в криптовалюте и фиате",
        },
        security: {
          title: "Безопасность",
          description: "Защита с помощью многоуровневого шифрования",
        },
        globalReach: {
          title: "Глобальный охват",
          description: "Работаем с клиентами по всему миру",
        },
        flexibleSettings: {
          title: "Гибкие настройки",
          description: "Адаптация под бизнес и пользователей",
        },
        transparency: {
          title: "Прозрачность",
          description: "Отсутствие скрытых комиссий",
        },
        instantSettlement: {
          title: "Мгновенный сеттлмент",
          description: "Средства доступны к выводу сразу после поступления платежа T+0",
        },
      },
    },
    howItWorks: {
      title: "Как работает Feennex для бизнеса?",
      steps: {
        createAccount: {
          title: "Создание аккаунта",
          description: "Регистрация и настройка платежного кабинета",
        },
        connectApi: {
          title: "Подключение API",
          description: "Простая интеграция в ваш бизнес",
        },
        payments: {
          title: "Прием и отправка платежей",
          description: "Моментальные переводы в криптовалюте и фиате",
        },
        management: {
          title: "Управление финансами",
          description: "Аналитика, отчеты, конвертация",
        },
      },
    },
    footer: {
      tagline: "Принимайте платежи в криптовалюте и фиате",
      contact: "Связаться с нами",
      service: "Сервис",
      apiDocs: "API Документация",
      documents: "Документы",
      privacy: "Политика конфиденциальности",
      terms: "Пользовательское соглашение",
      copyright: "Copyright © 2025 feennex.com Все права защищены",
    },
    policies: {
      aml: {
        title: "Политика противодействия отмыванию денег",
        content: "... AML policy content in Russian ..."
      },
      privacy: {
        title: "Политика конфиденциальности",
        content: "... Privacy policy content in Russian ..."
      },
      terms: {
        title: "Пользовательское соглашение",
        content: "... Terms of Service content in Russian ..."
      }
    },
    aml: {
        title: "Политика противодействия отмыванию денег",
        content: `
            <h2>1. Введение</h2>
            <p>1.1. Эта Политика противодействия отмыванию денег (AML) определяет обязательства Feennex по предотвращению отмывания денег и финансирования терроризма.</p>
            <p>1.2. Мы поддерживаем строгое соблюдение международных норм AML.</p>

            <h2>2. Надлежащая проверка клиентов</h2>
            <p>2.1. Мы внедряем следующие меры:</p>
            <ul>
                <li>Идентификация и верификация клиентов</li>
                <li>Оценка рисков клиентов и транзакций</li>
                <li>Постоянный мониторинг транзакций</li>
                <li>Ведение записей всех верификаций</li>
            </ul>

            <h2>3. Оценка рисков</h2>
            <p>3.1. Мы оцениваем риски на основе:</p>
            <ul>
                <li>Профиля клиента</li>
                <li>Шаблонов транзакций</li>
                <li>Географического расположения</li>
                <li>Деловых отношений</li>
            </ul>

            <h2>4. Мониторинг транзакций</h2>
            <p>4.1. Мы отслеживаем транзакции на предмет:</p>
            <ul>
                <li>Подозрительных шаблонов</li>
                <li>Крупных транзакций</li>
                <li>Необычной активности</li>
                <li>Индикаторов высокого риска</li>
            </ul>

            <h2>5. Отчетность</h2>
            <p>5.1. Мы сообщаем о подозрительной деятельности соответствующим органам.</p>
            <p>5.2. Мы сохраняем конфиденциальность отчетов и расследований.</p>

            <h2>6. Обучение персонала</h2>
            <p>6.1. Наш персонал регулярно проходит обучение по AML.</p>
            <p>6.2. Мы поддерживаем актуальные процедуры соответствия.</p>
        `
    },
    privacy: {
        title: "Политика конфиденциальности",
        content: `
            <h2>1. Введение</h2>
            <p>1.1. Эта Политика конфиденциальности объясняет, как Feennex собирает, использует и защищает вашу личную информацию.</p>
            <p>1.2. Мы обязуемся обеспечивать вашу конфиденциальность и защищать ваши данные.</p>

            <h2>2. Информация, которую мы собираем</h2>
            <p>2.1. Мы собираем следующие типы информации:</p>
            <ul>
                <li>Личная идентификационная информация</li>
                <li>Контактная информация</li>
                <li>Данные о транзакциях</li>
                <li>Информация об использовании</li>
            </ul>

            <h2>3. Как мы используем вашу информацию</h2>
            <p>3.1. Мы используем вашу информацию для:</p>
            <ul>
                <li>Обработки ваших транзакций</li>
                <li>Предоставления поддержки клиентам</li>
                <li>Улучшения наших услуг</li>
                <li>Соблюдения законодательных требований</li>
            </ul>

            <h2>4. Безопасность данных</h2>
            <p>4.1. Мы внедряем надежные меры безопасности для защиты ваших данных.</p>
            <p>4.2. Мы используем шифрование и безопасные протоколы для передачи данных.</p>

            <h2>5. Ваши права</h2>
            <p>5.1. Вы имеете право:</p>
            <ul>
                <li>Получить доступ к своим персональным данным</li>
                <li>Запросить исправление данных</li>
                <li>Запросить удаление данных</li>
                <li>Отозвать согласие</li>
            </ul>

            <h2>6. Свяжитесь с нами</h2>
            <p>6.1. По вопросам конфиденциальности обращайтесь по адресу support@feennex.com</p>
        `
    },
    agreement: {
        title: "Пользовательское соглашение",
        content: `
            <h2>1. Общие положения</h2>
            <p>1.1. Настоящее Пользовательское соглашение регулирует отношения между Feennex ("Сервис") и пользователями относительно использования платежного сервиса.</p>
            <p>1.2. Используя наш Сервис, вы полностью соглашаетесь с этими условиями.</p>

            <h2>2. Описание услуг</h2>
            <p>2.1. Feennex предоставляет услуги по обработке платежей в криптовалюте и фиатной валюте.</p>
            <p>2.2. Сервис включает, но не ограничивается:</p>
            <ul>
                <li>Обработка криптовалютных платежей</li>
                <li>Операции с фиатной валютой</li>
                <li>Услуги конвертации валют</li>
                <li>Инструменты управления платежами</li>
            </ul>

            <h2>3. Обязанности пользователя</h2>
            <p>3.1. Пользователи должны:</p>
            <ul>
                <li>Предоставлять точную информацию</li>
                <li>Обеспечивать безопасность своей учетной записи</li>
                <li>Соблюдать действующее законодательство</li>
                <li>Не использовать сервис для незаконной деятельности</li>
            </ul>

            <h2>4. Комиссии за услуги</h2>
            <p>4.1. Структура комиссий прозрачна и доступна в панели пользователя.</p>
            <p>4.2. Комиссии могут обновляться с предварительным уведомлением пользователей.</p>

            <h2>5. Ответственность</h2>
            <p>5.1. Сервис предоставляется "как есть" без гарантий.</p>
            <p>5.2. Пользователи несут ответственность за свои транзакции и безопасность учетной записи.</p>

            <h2>6. Изменения в условиях</h2>
            <p>6.1. Мы можем обновлять эти условия с уведомлением пользователей.</p>
            <p>6.2. Продолжение использования после изменений означает принятие.</p>
        `
    },
};